// extracted by mini-css-extract-plugin
export var borderRadius = "_ej-4";
export var large = "_ej-3";
export var logoContainer = "_ej-0";
export var nameLogo = "_ej-2";
export var small = "_ej-1";